import { cva, VariantProps } from 'class-variance-authority'

export type PersonSelectFilterTriggerStyling = VariantProps<typeof personSelectFilterTriggerStyling>

export const personSelectFilterTriggerStyling = cva('flex items-center rounded-full border border-gray-100 w-full sm:w-44 overflow-hidden h-fit p-1', {
  variants: {
    size: {
      sm: 'h-fit',
      md: 'h-fit',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type PersonSelectFilterIconStyling = VariantProps<typeof personSelectFilterIconStyling>

export const personSelectFilterIconStyling = cva('flex items-center rounded-full bg-neutral-50', {
  variants: {
    size: {
      sm: 'p-1.5',
      md: 'p-2',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type PersonSelectFilterTextStyling = VariantProps<typeof personSelectFilterTextStyling>

export const personSelectFilterTextStyling = cva('h-full flex items-center text-gray-700 w-full gap-1', {
  variants: {
    size: {
      sm: 'p-0.5 text-xs',
      md: 'p-0.5 text-sm',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
